export default __webpack_public_path__ + "static/media/Prosecco.4531835e.mp3";